import { Link } from 'react-router-dom'
import { site } from '../data/site.js'

/* `tone` follows the header pill. "SPECTRA" was hardcoded white, so the moment
   the pill went light on a light section the word vanished and only the blue
   "NOX" was left. */
export default function Logo({ className = '', tone = 'dark' }) {
  return (
    <Link to="/" className={`group inline-flex items-center gap-2.5 ${className}`}>
      <img
        src="/images/spectranox.webp"
        alt={`${site.name} logo`}
        className="h-9 w-9 rounded-xl object-cover transition-transform group-hover:scale-105"
      />
      <span
        aria-label={site.name}
        className="font-display text-[20px] font-extrabold uppercase leading-none"
        style={{ letterSpacing: '0.02em', color: tone === 'light' ? '#0f172a' : '#ffffff' }}
      >
        SPECTRA<span style={{ color: tone === 'light' ? '#1d4ed8' : '#1c8eff' }}>NOX</span>
      </span>
    </Link>
  )
}
